export default "__VITE_ASSET__CJYgGJlq__"